import Swiper from 'swiper/bundle'; 
import 'swiper/swiper-bundle.css';

const initializeCertificacoes = () => {
  const section = document.querySelector('#certificacoes');
  if (!section) return;

  let trofeusSwiper;


	const inizializeSlide = (nSlider) =>{


		if(nSlider.length == 0 || nSlider.length == undefined) return 0;


		if(nSlider.length % 2 == 1){
			return (((nSlider.length - 1) / 2) + 1) - 1;
		}else{
			return (nSlider.length / 2) - 1;
		}
	}


  const initSwipers = () => {
    const commonSettings = (paginationEl, nextEl, prevEl, qntSlider = 0) => ({
      loop: false,
      slidesPerView: 'auto', // permite centralização exata por CSS
      spaceBetween: 24,
			initialSlide: inizializeSlide(qntSlider),
      centeredSlides: true, // centraliza o slide ativo
      slideToClickedSlide: true,
      speed: 1000, 
      pagination: {
        el: paginationEl,
        clickable: true,
        renderBullet: (index, className) =>
          `<span class="${className} custom-bullet"></span>`,
      },
      navigation: {
        nextEl,
        prevEl,
      },
    });

    // Inicializa Troféus
    trofeusSwiper = new Swiper(
      section.querySelector('.mySwiperTrofeus'),
      commonSettings(
        section.querySelector('.trofeus-pagination'),
        section.querySelector('.trofeus-next'),
        section.querySelector('.trofeus-prev'),
				section.querySelectorAll('.mySwiperTrofeus .swiper-slide')
      )
    );

    // Inicializa Selos
    const selosSwiper = new Swiper(
      section.querySelector('.mySwiperSelos'),
      commonSettings(
        section.querySelector('.selos-pagination'),
        section.querySelector('.selos-next'),
        section.querySelector('.selos-prev'),
				section.querySelectorAll('.mySwiperSelos .swiper-slide')
      )
    );

    observer.disconnect(); // Evita múltiplas execuções
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          initSwipers();
        }
      });
    },
    {
      threshold: 0.1,
    }
  );

  observer.observe(section);
};

export default initializeCertificacoes;
